var React = require('react');

function CartCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.62,20.42c-2.46-3.89-2.04-13.2,0.77-16.86c3.16-4.13,9.85-4.13,14.3-2.71c7.15,2.36,13.95,13.67,9.61,20.75\n\tC21.85,28.67,4.78,26.43,1.62,20.42"}));
}

CartCircle.defaultProps = {"viewBox":"0 0 27.66 26","preserveAspectRatio":"none"};

module.exports = CartCircle;

CartCircle.default = CartCircle;
